import React from 'react';
import { SCHOOL_CONFIG } from '../../config/appConfig';
import LoginForm from './LoginForm';
import useSchoolStore from '../../store/schoolStore';

/**
 * The sign-in screen: one centred card with the school's logo and name, then the form.
 */
const LoginPage = () => {
  const { schoolData } = useSchoolStore();
  const schoolName = schoolData?.name;

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-ui-page px-4 py-10">
      <div className="w-full max-w-sm rounded-xl border border-ui-line bg-ui-card p-7 shadow-card">
        <div className="mb-6 text-center">
          <img
            className="mx-auto size-12 rounded-lg object-contain"
            src={schoolData?.iconUrl || SCHOOL_CONFIG.branding.logo}
            alt=""
          />
          <h1 className="mt-4 text-xl font-semibold tracking-tight text-ui-ink">
            {schoolName || 'SchoolLine'}
          </h1>
          <p className="mt-1 text-sm text-ui-ink-2">Sign in to the school dashboard</p>
        </div>

        <LoginForm />
      </div>

      <p className="mt-6 flex items-center gap-2 text-xs text-ui-ink-3">
        <img src="/assets/logo.png" alt="" className="size-4 object-contain" />
        SchoolLine
      </p>
    </div>
  );
};

export default LoginPage;
